export const LoginPath = {
  Login: '/login',
} as const
